import axios from "axios";
import {
  STRAPI_DEV_URL,
  STRAPI_PROD_URL,
} from "../../../services/strapi-content/strapiContent.constants";

export default {
  state: {
    gamesCertificationsDropboxPath: null,
    gamesLogoDropboxPath: null,
    gamesMasterListDropboxPath: null,
    restrictedTerritoriesDropboxPath: null,
  },
  mutations: {
    SET_GAMES_CERTIFICATIONS_DROPBOX_PATH(state, path) {
      state.gamesCertificationsDropboxPath = path;
    },
    SET_GAMES_LOGO_DROPBOX_PATH(state, path) {
      state.gamesLogoDropboxPath = path;
    },
    SET_GAMES_MASTER_LIST_DROPBOX_PATH(state, path) {
      state.gamesMasterListDropboxPath = path;
    },
    SET_RESTRICTED_TERRITORIES_DROPBOX_PATH(state, path) {
      state.restrictedTerritoriesDropboxPath = path;
    },
  },
  actions: {
    // Fetch glossary items from Strapi API using axios
    async fetchContentItems(context, payload) {
      const enviroment =
        process.env.VUE_APP_ENV === "development"
          ? STRAPI_DEV_URL
          : STRAPI_PROD_URL;
      try {
        const response = await axios.get(`${enviroment}${payload.link}`);
        return response;
      } catch (error) {
        console.log(error);
        return error;
      }
    },

    updateGamesCertificationsDropboxPath({ commit }, path) {
      commit("SET_GAMES_CERTIFICATIONS_DROPBOX_PATH", path);
    },
    updateGamesLogoDropboxPath({ commit }, path) {
      commit("SET_GAMES_LOGO_DROPBOX_PATH", path);
    },
    updateGamesMasterListDropboxPath({ commit }, path) {
      commit("SET_GAMES_MASTER_LIST_DROPBOX_PATH", path);
    },
    updateRestrictedTerritoriesDropboxPath({ commit }, path) {
      commit("SET_RESTRICTED_TERRITORIES_DROPBOX_PATH", path);
    },
  },
};
